import { render, staticRenderFns } from "./ResetByPass.vue?vue&type=template&id=6714f853"
import script from "./ResetByPass.vue?vue&type=script&lang=js"
export * from "./ResetByPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports